import * as React from 'react';
import { ModalProps } from 'react-bootstrap';
import { PVADiamond } from '../../components';
import { Style } from '../../models';
import './Modal.css';

interface ModelContentProps extends ModalProps {
    title: string;
    content: string;
    complexContent?: any;
    footer?: any;
    additional?: any;
    simpleTitle?: boolean;
    style?: Style;
    useStyleNameInHeader?: boolean;
}

export class PonderaModal extends React.Component<ModelContentProps> {
    constructor(props: ModelContentProps) {
        super(props);
    }

    onHide(): any {
        this.props.onHide();
    }

    render() {
        if (!this.props.show) {
            return <div />;
        }
        return (
            <div className="modal-container">
                <div className="row">
                    <div className="col-xs-offset-1 col-xs-10 col-sm-offset-2 col-sm-8">
                        <div className="modal-dialog">
                            <div className="modal-content" role="document">
                                <div id={this.props.title} className="modal-header pva-group-title pondera-modal-header">
                                    <button type="button" className="close pondera-close" onClick={(e) => this.onHide()}>
                                        <span className="glyphicon glyphicon-remove" />
                                        <span className="sr-only">Close</span>
                                    </button>
                                    <div className="modal-header-diamond">
                                        {!this.props.style && <PVADiamond step={0} />}
                                        {this.props.style && <PVADiamond style={this.props.style.name} step={4} />}
                                    </div>
                                    {this.props.useStyleNameInHeader && <div className="modal-title pondera-modal-title pondera-modal-title-style-name">
                                        {this.props.style && <div className="title-top">{this.props.style.name}</div>}
                                        <div className="title-bottom" dangerouslySetInnerHTML={{ __html: this.props.title }} />
                                    </div>}
                                    {!this.props.useStyleNameInHeader && <h3 className={`modal-title ${this.props.simpleTitle ? '' : 'pondera-modal-title'}`}>
                                        <span dangerouslySetInnerHTML={{ __html: this.props.title }} />
                                    </h3>}
                                </div>
                                <div className="modal-body">
                                    <div dangerouslySetInnerHTML={{ __html: this.props.content }} />
                                    {
                                        this.props.complexContent
                                    }
                                </div>
                                <div className="modal-footer">
                                    <div className="row">
                                        <div className="col-xs-6 text-left">
                                            {this.props.footer}
                                        </div>
                                        <div className="col-xs-6">
                                            {this.props.additional}
                                            <button onClick={(e) => this.onHide()} type="button" className="btn btn-default">Close</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/inclinationmodals/PonderaModal.tsx